module.exports = __webpack_public_path__ + "media/presentation.1c91ad3b.mp4";